module.exports = __webpack_public_path__ + "static/media/deleteSvg.0f141cc2.svg";